const DAY_OFFSETS = {
  ArrowLeft: -1,
  ArrowRight: 1,
  ArrowUp: -7,
  ArrowDown: 7,
};

export const getCalendarDateForKey = (currentDate, key) => {
  if (!(currentDate instanceof Date) || Number.isNaN(currentDate.getTime())) {
    return null;
  }

  const target = new Date(currentDate);
  if (key in DAY_OFFSETS) {
    target.setDate(target.getDate() + DAY_OFFSETS[key]);
    return target;
  }

  if (key === 'Home') {
    target.setDate(target.getDate() - target.getDay());
    return target;
  }

  if (key === 'End') {
    target.setDate(target.getDate() + (6 - target.getDay()));
    return target;
  }

  if (key === 'PageUp' || key === 'PageDown') {
    const direction = key === 'PageUp' ? -1 : 1;
    const originalDay = target.getDate();
    target.setDate(1);
    target.setMonth(target.getMonth() + direction);
    const lastDay = new Date(
      target.getFullYear(),
      target.getMonth() + 1,
      0
    ).getDate();
    target.setDate(Math.min(originalDay, lastDay));
    return target;
  }

  return null;
};
